module.exports = __webpack_public_path__ + "img/AppstoreListing_HomeScreen.a043ac35.png";